import {createGlobalStyle} from 'styled-components'

import backgroundImage from './images/background.svg'

export const GlobalStyle = createGlobalStyle`
  html {
    min-height: 100vh;
    background: url('${backgroundImage}') no-repeat;
    background-size: cover;
    background-attachment: fixed;
  }

  body {
    margin: 0;
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    min-height: 100vh;

    & div[class*="StyledGrommet"] {
      // Grommet div - bit of a hack, need to find a way of making it better late
      min-height: 100vh;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
    }
  }
`
